var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b-form-checkbox',{on:{"input":function($event){return _vm.callback($event, _vm.item)}},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }